import { FC } from 'react';
import styled, { css } from 'styled-components';

import { EdnaWrapper } from '@providers/index';

import Text from '@components/Text';
import { EmptyStateProps } from './types';

const EmptyStateWrapper = styled.div<{
  $margin?: string;
  $padding?: string;
  $asCard: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.$padding};
  margin: ${(props) => props.$margin};
  ${(props) =>
    props.$asCard &&
    css`
      background-color: ${(props) => props.theme.colors.white};
      border: 1px solid ${(props) => props.theme.colors.grey100};
      border-radius: 8px;
    `}
`;
const Content = styled.div<{ $maxWidth: string }>`
  width: 100%;
  max-width: ${(props) => props.$maxWidth};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 12px;
  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};
  }
`;
const Image = styled.img<{ $maxHeight: string }>`
  width: 100%;
  max-height: ${(props) => props.$maxHeight};
  margin-bottom: 24px;
  object-fit: contain;
`;
const CallToActions = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
`;

const EmptyState: FC<EmptyStateProps> = ({
  callToAction,
  className,
  header,
  image,
  imageMaxHeight = '142px',
  contentMaxWidth = '650px',
  margin,
  padding = '60px 20px',
  message,
  asCard = true,
}: EmptyStateProps) => {
  return (
    <EdnaWrapper>
      <EmptyStateWrapper
        aria-label="Empty State"
        className={className}
        $margin={margin}
        $padding={padding}
        $asCard={asCard}
      >
        {image &&
          (typeof image === 'string' ? (
            <Image
              src={image}
              alt="Empty State Image"
              $maxHeight={imageMaxHeight}
            />
          ) : (
            image
          ))}
        <Content $maxWidth={contentMaxWidth} title="Empty State Content">
          <Text
            variant="headingLg"
            fontWeight={600}
            element="h2"
            align="center"
          >
            {header}
          </Text>
          <Text variant="bodyLg" element="div" color="grey600" align="center">
            {message}
          </Text>
          {callToAction && <CallToActions>{callToAction}</CallToActions>}
        </Content>
      </EmptyStateWrapper>
    </EdnaWrapper>
  );
};

export default EmptyState;
